import { Component, EventEmitter, OnInit, Optional, Output } from '@angular/core';
import { NbDialogRef, NbCardModule, NbSpinnerModule, NbAlertModule, NbButtonModule } from '@nebular/theme';
import { InvestmentHistoryService } from '../../../@core/utils';
import { BaseHistoryDialogComponent } from '../base-history-dialog/base-history-dialog.component';
import { SpreadsheetDialogManagerService } from './../../../@core/utils/spreadsheet-dialog-manager.service';
import { TranslateModule } from '@ngx-translate/core';
import { HistoryListComponent } from '../history-list/history-list.component';

@Component({
    selector: 'app-investment-history-dialog',
    styleUrls: ['../base-history-dialog/base-history-dialog.component.scss'],
    templateUrl: '../base-history-dialog/base-history-dialog.component.html',
    standalone: true,
    imports: [
        NbCardModule,
        NbSpinnerModule,
        HistoryListComponent,
        NbAlertModule,
        NbButtonModule,
        TranslateModule,
    ],
})
export class InvestmentHistoryDialogComponent extends BaseHistoryDialogComponent implements OnInit {

  @Output() isSubmit = new EventEmitter<boolean>();
  @Output() isClose = new EventEmitter<void>();

  public investmentId: number;

  constructor(
    private investmentHistoryService: InvestmentHistoryService,
    private dialogManagerService: SpreadsheetDialogManagerService,
    @Optional() public ref: NbDialogRef<InvestmentHistoryDialogComponent>
  ) {
    super();
  }

  public ngOnInit(): void {
    this.loading = true;
    this.error = false;
    if (!this.investmentId) {
      this.investmentId = this.dialogManagerService.inputData;
    }

    this.subscriptions.push(
      this.investmentHistoryService.loadHistoryForInvestment(this.investmentId).subscribe((hist) => {
        this.history = hist;
        this.loading = false;
      },
        () => {
          this.error = true;
          this.loading = false;
        }),
    );
  }

  public close(): void {
    this.isClose.emit();
    if (this.ref) {
      this.ref.close();
    }
  }
}
